import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import MetaTags from '../../../../../components/common/layouts/MetaTags';
import BookAvailable from '../../../../../components/hoc/BookAvailable';
import MerchantResourceBookPage from '../../../../../components/merchants/resources/books/express';
import Merchant from '../../../../../domain/entities/Merchant';
import implUCMerchantRepository from '../../../../../infrastructure/repositories/UCMerchantRepository';

interface Query {
  publicId: string;
  resource_id: string;
  selected_date?: string;
  selected_slot?: string;
  selected_lesson?: string;
  selected_course?: string;
  selected_staff?: string;
}

interface Props {
  session: string;
  merchant: Merchant;
  merchantId: string;
  resourceId: string;
  selectedDate?: string;
  selectedSlot?: string;
  selectedLesson?: string;
  selectedCourse?: string;
  selectedStaff?: string;
}

class MerchantResourceBook extends React.Component<Props & InjectedIntlProps> {
  public static async getInitialProps({
    query,
    session,
  }: {
    query: Query;
    session: string;
  }) {
    const {
      publicId,
      resource_id,
      selected_date,
      selected_slot,
      selected_lesson,
      selected_course,
      selected_staff,
    } = query;

    const { merchant } = await implUCMerchantRepository().Layout(publicId);

    const merchantId = publicId;
    const resourceId = resource_id;
    const selectedDate = selected_date;
    const selectedSlot = selected_slot;
    const selectedLesson = selected_lesson;
    const selectedCourse = selected_course;
    const selectedStaff = selected_staff;

    return {
      session,
      merchant,
      merchantId,
      resourceId,
      selectedDate,
      selectedSlot,
      selectedLesson,
      selectedCourse,
      selectedStaff,
    };
  }

  public render() {
    const { intl, merchant, merchantId, resourceId } = this.props;

    return (
      <>
        <MetaTags
          title={intl.formatMessage({ id: 'books.meta.title' })}
          currentUrl={`/${merchantId}/${resourceId}`}
          noIndex={merchant.metaSetting.isNoIndex}
        />
        <MerchantResourceBookPage {...this.props} />
      </>
    );
  }
}

export default BookAvailable<Props>(injectIntl(MerchantResourceBook));
